import { Component, Input, OnInit } from '@angular/core';
import { WellTests } from 'src/app/interfaces/well-tests';
import { HandoverService } from 'src/app/services/handover.service';

@Component({
  selector: 'app-handover-detail-tests',
  templateUrl: './handover-detail-tests.component.html',
  styleUrl: './handover-detail-tests.component.scss',
  standalone: false,
})
export class HandoverDetailTestsComponent implements OnInit {
  @Input() handoverId: number | undefined;
  @Input() wellName: string | undefined;
  @Input() handoverStatusId: number | undefined;

  wellTests: WellTests[] = [];
  isLoading = false;
  hideFooter = true;
  displayedColumns = [
    'startDate',
    'top',
    'base',
    'symbol',
    'qp',
    'qg',
    'qa',
    'gross',
    'level',
  ];

  constructor(public handoverService: HandoverService) {}

  ngOnInit(): void {
    if (this.handoverId && this.wellName) {
      this.isLoading = true;
      this.handoverService
        .getWellTests(this.handoverId, this.wellName!, this.handoverStatusId!)
        .subscribe((wt: WellTests[]) => {
          if (wt) {
            this.wellTests = wt;
            this.hideFooter = this.wellTests!.length > 0;
          }
          this.isLoading = false;
        });
    }
  }
}
